import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    sortBy: String,
    sortDirection: { type: String, default: "asc" },
  }

  connect() {
    this.refresh()
    this.observer = new MutationObserver(this.refresh.bind(this))
    this.observer.observe(this.element, { childList: true })
  }

  refresh() {
    if (this.sortByValue) this.sort()
    this.update()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  sort() {
    const items = Array.from(this.element.querySelectorAll(":scope > .soc-timeline-item"))
    if (items.length < 2) return

    // Convert snake_case or kebab-case to camelCase so it matches the dataset property name
    // e.g. "sort_key" -> "sortKey" to read element.dataset.sortKey
    const key = this.sortByValue.replace(/[-_](.)/g, (_, c) => c.toUpperCase())
    const dir = this.sortDirectionValue === "desc" ? -1 : 1

    items.sort((a, b) => {
      const aVal = a.dataset[key] ?? ""
      const bVal = b.dataset[key] ?? ""
      return dir * aVal.localeCompare(bVal, undefined, { numeric: true })
    })

    const anchor = this.element.querySelector(".soc-timeline-no-items") ?? null
    this.observer?.disconnect()
    items.forEach(item => this.element.insertBefore(item, anchor))
    this.observer?.observe(this.element, { childList: true })
  }

  update() {
    const noItems = this.element.querySelector(".soc-timeline-no-items")
    if (!noItems) return
    noItems.hidden = this.element.querySelector(".soc-timeline-item") !== null
  }

}
